
// from Xef’s GSOrderContentPrintStatusCalculator.m

import MenuItemType from './MenuItemType'

const NOT_PRINTED = 0
const HALF_PRINTED = 1
const PRINTED = 2

export default content => {
  const leftToPrint = Math.abs(content.quantity - content.alreadyPrintedQuantity)
  if (! leftToPrint) {
    return PRINTED
  }
  if (! content.alreadyPrintedQuantity) {
    return NOT_PRINTED
  }
  return HALF_PRINTED
}
